// @ts-check

import React from 'react';
import { node } from 'prop-types';

/**
 * @component ProfilePaper
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @returns {JSX.Element}
 */
function ProfilePaper({ children }) {
	return (
		<section
			style={{
				display: 'flex',
				flexDirection: 'column',
				gap: '1rem',
				padding: '1rem',
				backgroundColor: 'var(--cl-paper-bg-main)',
				borderRadius: '0.5rem',
			}}
		>
			{children}
		</section>
	);
}

ProfilePaper.propTypes = { children: node };

export default ProfilePaper;
